import { ChevronDownIcon, InfoOutlineIcon, CloseIcon } from '@chakra-ui/icons';
import {
  Box, Button, Checkbox, CheckboxGroup, Divider, Flex, Icon, Input,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  ModalFooter,
  Select,
  Switch,
  Text, Textarea,
  Tooltip,
  useDisclosure,
  useToast,
  Image,
  useColorModeValue,
  IconButton,
  ButtonGroup,
  Link
} from '@chakra-ui/react';
import AiImageModal from 'components/aiHub/AiImageModal';
import AiVideoModal from 'components/aiHub/AiVideoModal';
import DeleteConfirmationModal from 'components/genericForms/DeleteConfirmationModal';
import { useFormik } from 'formik';
import React, { useEffect, useMemo, useState } from 'react';
import { BsStars } from 'react-icons/bs';
import { MdDelete, MdEdit } from "react-icons/md";
import { IoBuildOutline, IoPlayCircleOutline } from 'react-icons/io5';
import PhoneInput from 'react-phone-input-2';
import { useSelector } from 'react-redux';
import { useCreateAdspressoCreativeMutation, useRemoveAdMutation, useUpdateAdspressoAdCreativeByIdMutation } from 'store/adspresso/adspressoAdApi';
import { useGetAdvertisableAppsByIdQuery } from 'store/campaigns/adsetFormApi';
import { formatDateTime, getFileNameWithoutExtension, getStepMeta, removeEmptyValues, StepButton, truncateString } from 'utils/functions';
import { object, string } from "yup";
import BuildUrlParams from '../BuildUrlParams';
import UrlParameter from '../UrlParameter';
import ReplaceDriveModal from 'components/drive/ReplaceDriveModal';
import { FaExchangeAlt } from 'react-icons/fa';
import imagePlacementConfig from 'utils/imagePlacementConfig.json';
import videoPlacementConfig from 'utils/videoPlacementConfig.json';
import ReplaceComponent from 'components/genericForms/ReplaceComponent';
import DriveComponent from 'components/drive/DriveComponent';
import { selectCallsData, selectLandersData } from 'store/aiHub/aiSlice';
import { FiPhoneCall } from 'react-icons/fi';
import { call_to_action_options_Awareness_Traffic_Engagement } from 'utils/callToActions';

function isValidUrl(url) {
  const regex = /^(https?:\/\/)?([\w\d\-]+\.)+[a-zA-Z]{2,}(\/[^\s]*)?$/;
  return regex.test(url);
}

const isValidPhoneNumber = (phoneNumber) => {
  if (!phoneNumber) return false;

  // Country code: 1–3 digits
  const countryCodePattern = /^\d{1,3}/;
  const match = phoneNumber.match(countryCodePattern);
  if (!match) return false;

  const countryCode = match[0];
  const phoneNumberPart = phoneNumber.slice(countryCode.length);

  // Local number: 6–12 digits
  const regex = /^\d{6,12}$/;
  return regex.test(phoneNumberPart);
};


function SingleObjectiveMediaCreative({ adsAccounts, adFormik, adsetsListData, objective, campaignId, adData }) {

  const boxBorder = useColorModeValue("gray.200", "gray.700");
  const bgColor = useColorModeValue("#F5F3F9", "#1e1530");
  const textColor = useColorModeValue("#421e66", "#b5b5cd");
  const hoverBorderColor = useColorModeValue("gray.300", "brand.800");
  const bgGradient = useColorModeValue(
    "linear-gradient(180deg, #f8f6fb 10%, #b0a8bf 130%)", 
    "linear-gradient(180deg, #1a202c 10%, #1b1845 130%)"   
  );
  const bgInput = useColorModeValue('#f8f6fb', '#1e1530');
  const ListBgColor = useColorModeValue('#fff', 'gray.800');
  const hoverBorder = useColorModeValue('gray.50', 'gray.700');
  const toast = useToast();
  const { isOpen: isEditModalOpen, onOpen: OnEditModalOpen, onClose: OnEditModalClose } = useDisclosure();
  const { isOpen: isReplaceModalOpen, onOpen: OnReplaceModalOpen, onClose: OnReplaceModalClose } = useDisclosure();
  const { isOpen: isAiImageModalOpen, onOpen: onAiImageModalOpen, onClose: onAiImageModalClose } = useDisclosure();
  const { isOpen: isAiVideoModalOpen, onOpen: onAiVideoModalOpen, onClose: onAiVideoModalClose } = useDisclosure();
  const { isOpen: isCreativeModalOpen, onOpen: onCreativeModalOpen, onClose: onCreativeModalClose} = useDisclosure();
  const [activeStep, setActiveStep] = useState("Media"); // 'Media' | 'Replace'
  const [hasSelectedFiles, setHasSelectedFiles] = useState(false);
  const [mediaType, setMediaType] = useState(null);
  const [uploadPurpose, setuploadPurpose] = useState(null);
  const [selectedAdAccounts, setSelectedAdAccounts] = useState([]);
  const [selectedAdSets, setSelectedAdSets] = useState({});
  const [mediaFiles, setMediaFiles] = useState([]);
  const [hasSameDestinationType, sethasSameDestinationType] = useState(true);
  const [isVideoOptimized, setIsVideoOptimized] = useState(false);
  const [activeDestinationType, setactiveDestinationType] = useState('');
  const [isModalOpen, setModalOpen] = useState(false);
  const [selectedAd, setSelectedAd] = useState(null);
  const userInfo = useSelector((state) => state.auth?.userInfo);
  const callsData = useSelector(selectCallsData);
  const landersData = useSelector(selectLandersData);
  const [isUrlModalOpen, setUrlModalOpen] = useState(false);
  const [isUrlParamModalOpen, setUrlParamModalOpen] = useState(false);
  const [selectedAccountId, setSelectedAccountId] = useState(null);
  const [links, setLinks] = useState([]);
  const [phoneNumbers, setPhoneNumbers] = useState([]);
  const [url_tags, seturl_tags] = useState([]);
  const [isFocused, setIsFocused] = useState({});
  const [selectedMediaUrls, setselectedMediaUrls] = useState([]);
  const [editingGroupIndex, setEditingGroupIndex] = useState(null);
  const [replacingIndex, setReplacingIndex] = useState({ groupIndex: null, placementIndex: null });
  const [showSavedPhones, setShowSavedPhones] = useState({});
  const [showSavedLanders, setShowSavedLanders] = useState({});

  const adsAccountIds =  adData?.adsAccounts.map(account => account?.adsAccountId);

  const { data: advertisableApps } = useGetAdvertisableAppsByIdQuery({
    adsAccountIds
  }, {
    skip: !adsAccountIds
  });

  const [createAdspressoAds, { isLoading: isAdsCreating, error: createError }] = useCreateAdspressoCreativeMutation();
  const [removeAd, removeAdResponse] = useRemoveAdMutation();

  const handleMediaTypeChange = (adAccounts, type) => {
    setSelectedAdAccounts(adAccounts);
    setMediaType(type);
    setHasSelectedFiles(false);
    onCreativeModalOpen();
  }

  const handleAdAccountChange = (selectedValues) => {
    const selectedAccounts = adsAccounts.filter(account => selectedValues.includes(account.adsAccountId));
    setSelectedAdAccounts(selectedAccounts);

    // Filter out media files associated with deselected accounts
    const updatedMediaFiles = mediaFiles.filter(file =>
      selectedValues.includes(file?.adsAccount?.adsAccountId)
    );
    setMediaFiles(updatedMediaFiles);

    // Filter selectedMediaUrls similarly — keep only inner arrays where the adsAccountId matches selectedValues
    const updatedSelectedMediaUrls = selectedMediaUrls
      .map(mediaGroup => mediaGroup.filter(media => selectedValues.includes(media.adsAccountId)))
      .filter(mediaGroup => mediaGroup.length > 0); // remove empty inner arrays

    setselectedMediaUrls(updatedSelectedMediaUrls);

    // Update links state with initial empty URLs for selected ad accounts
    setLinks(prevLinks => {
      const updatedLinks = selectedAccounts.map(account => {
        const existing = prevLinks.find(link => link?.adsAccountId === account?.adsAccountId);
        return {
          adsAccountId: account?.adsAccountId,
          link: existing?.link || '',
          caption: existing?.caption || '',
          app_id: existing?.app_id || '',
        };
      });
      return updatedLinks;
    });   
    
    // Update phoneNumbers state with initial empty phone numbers for selected ad accounts
    setPhoneNumbers(prevPhoneNumbers => {
      const updatedPhoneNumbers = selectedAccounts.map(account => ({
        adsAccountId: account?.adsAccountId,
        phoneNumber: prevPhoneNumbers.find(phone => phone?.adsAccountId === account?.adsAccountId)?.phoneNumber || '' // keep previous value if exists
      }));
      return updatedPhoneNumbers;
    });

    seturl_tags(prevUrl => {
      const updatedurl_tags = selectedAccounts.map(account => ({
        adsAccountId: account?.adsAccountId,
        url_tags: prevUrl.find(url => url?.adsAccountId === account?.adsAccountId)?.url_tags || '' // keep previous value if exists
      }));
      return updatedurl_tags;
    });
  };

  const handleAdSetChange = (selectedValues) => {

    setSelectedAdSets(prev => {
      const updated = {};
      selectedAdAccounts.forEach(account => {
        updated[account.adsAccountId] = selectedValues;
      });
      return updated;
    });
  };

  const handleFileSelect = (files) => {

    if (files.length > 0){
        // Handle creation scenario
        setMediaFiles(prevFiles => [...prevFiles, ...files])

          const placements = ['square', 'vertical', 'horizontal'];

          const fileData = files.map((file) =>
            placements.map((placement) => ({
              placement,
              url: file?.url ? file?.url : file?.picture,
              source: file?.source,
              mediaType: file?.url ? 'image' : 'video',
              hash: file?.creativeId,
              mediaHash: file?.hash,
              name: file?.name,
              adsAccountId: file?.adsAccount?.adsAccountId,
              adsAccountName: file?.adsAccount?.adsAccountName
            }))
          );

          setselectedMediaUrls(prev => [...prev, ...fileData]);
    }
  };

  let schema = object().shape({
    destinationType: string(),
    type: string()
      .required('Type is required'),
  })

  const singleMediaFormik = useFormik({
    enableReinitialize: true,
    initialValues: {
      destinationType: activeDestinationType,
      message: '',
      name: '',
      description: '',
      type: activeDestinationType === 'PHONE_CALL' ? 'CALL_NOW' : activeDestinationType === 'ON_PAGE' ? 'LIKE_PAGE' : 'SHOP_NOW',
      applyForAll: false,
      message: '',
      mediaFiles: [],
      link: [],
      phoneNumber: [],
      url_tags: [],
      pac_relaxation_enroll_status: "OPT_IN",
    },
    validationSchema: schema,
    onSubmit: (values, { resetForm }) => {

      const { name, message, description, type, link, phoneNumber, url_tags, pac_relaxation_enroll_status } = values;

      const matchingGroups = [];
      const nonMatchingGroups = [];

      selectedMediaUrls.forEach(group => {
        const allMatch = group.every(item => item.hash === group[0].hash);
        if (allMatch) {
          matchingGroups.push(group);
        } else {
          nonMatchingGroups.push(group);
        }
      });

      let allMediaData = [];
      let allAssetCustomizationRules = [];

      nonMatchingGroups.forEach(group => {
        const hashMap = {};
        const seenHashes = new Set();
        const hashDuplicates = new Map();

        // Step 1: Build hashMap
        group.forEach(item => {
          hashMap[item.hash] = {
            mediaType: item.mediaType,
            placement: item.placement
          };
        });

        // Step 2: Identify duplicates
        group.forEach(item => {
          if (seenHashes.has(item.hash)) {
            if (!hashDuplicates.has(item.hash)) {
              hashDuplicates.set(item.hash, []);
            }
            hashDuplicates.get(item.hash).push(item.placement);
          } else {
            seenHashes.add(item.hash);
          }
        });

        // Reset for second pass
        seenHashes.clear();

        // Step 3: Deduplicate & tag
        const mediaData = group
          .filter(item => {
            if (seenHashes.has(item.hash)) return false;
            seenHashes.add(item.hash);
            return true;
          })
          .map(item => {
            const duplicatePlacements = hashDuplicates.get(item.hash);
            const tag = duplicatePlacements?.length
              ? { duplicatePlacements }
              : undefined;

            return {
              [item.mediaType === 'image' ? 'hash' : 'video_id']: item.hash,
              thumbnail_url: item.url,
              [item.mediaType === 'image' ? 'creative_hash' : 'hash']: item.mediaHash,
              adlabels: [{ name: item.placement }],
              ...(tag && { tag }),
              fileName: item?.name,
              mediaType: item.mediaType,
              adsAccountId: item?.adsAccountId,
            };
          });

        // Step 4: Build asset_customization_rules
        const asset_customization_rules = mediaData.map(media => {
          const meta = hashMap[media.mediaType === 'image' ? media.hash : media.video_id];
          if (!meta) return null;

          const { mediaType } = meta;
          const isDuplicate = media.tag?.duplicatePlacements?.length > 0;

          return (media.adlabels || []).map(label => {
            const placement = label.name;
            if (!placement) return null;

            return {
              [mediaType === 'image' ? 'image_label' : 'video_label']: { name: placement },
              customization_spec: isDuplicate
                ? {}
                : (mediaType === 'image' ? imagePlacementConfig : videoPlacementConfig)[placement] || {}
            };
          });
        }).flat().filter(Boolean); // flatten & remove nulls

        // Merge into global arrays
        allMediaData.push(mediaData);
        allAssetCustomizationRules.push(asset_customization_rules);
      });

      const urlTags = url_tags.filter(account => account.url_tags?.trim());

      const adsAccounts = selectedAdAccounts?.map(account => ({
        id: account?.id,
        adsAccountId: account?.adsAccountId,
        adsAccountName: account?.adsAccountName,
        businessName: account?.businessName,
        businessId: account?.businessId,
      }));


      // Step 1: Flatten selected ad sets
      const adsets = adsAccounts.flatMap(account => selectedAdSets[account.adsAccountId] || []);

      // Step 2: Deduplicate by `_id`
      const uniqueAdsets = adsets.filter(
        (item, index, self) => index === self.findIndex(i => i._id === item._id)
      );

      // Step 3: Enrich with `promoted_object` from adsetsListData
      const enrichedAdsets = uniqueAdsets.map(selected => {
        const matched = adsetsListData?.data?.find(adset => adset._id === selected);
        return {
          promoted_object: matched?.promoted_object || {}
        };
      });

      const adcreatives = allMediaData.map((mediaGroup, index) => {
        const rules = allAssetCustomizationRules[index];
        const representative = mediaGroup[0];

        const adsAccountId = representative?.adsAccountId || '';
        const fileName = representative?.fileName || 'Untitled';

        const matchedLink = link.find(item => item.adsAccountId === adsAccountId)?.link;
        const matchedCaption = link.find(item => item.adsAccountId === adsAccountId)?.caption;
        const matchedPhoneNumber = phoneNumber.find(item => item.adsAccountId === adsAccountId)?.phoneNumber;
        const matchedPageId = adFormik?.values?.accounts.find(item => item.adsAccountId === adsAccountId)?.page_id;

        // Clean out  from mediaGroup
        const cleanedMediaGroup = mediaGroup.map(({ tag, fileName, mediaType, adsAccountId, ...rest }) => rest);

        return {
          fileName,
          adsAccountId,
          [representative?.mediaType === 'image' ? 'url' : 'thumbnail']: representative?.thumbnail_url || '',
          asset_feed_spec: {
            optimization_type: 'PLACEMENT',
            ad_formats: [representative?.mediaType === 'image' ? 'SINGLE_IMAGE' : 'SINGLE_VIDEO'],
            [representative?.mediaType === 'image' ? 'images' : 'videos']: cleanedMediaGroup,
            asset_customization_rules: rules,
            ...(message && { bodies: [{ text: message }] }),
            ...(name && { titles: [{ text: name }] }),
            ...(description && { descriptions: [{ text: description }] }),
            call_to_action_types: [type],
            ...(['PHONE_CALL'].includes(activeDestinationType) && {
              call_to_actions: [{
                type,
                value:{
                  link: `tel:+${matchedPhoneNumber}`
                }
              }]
            }),
            link_urls: [{
              website_url: type === 'CALL_NOW' ? `https://facebook.com/${matchedPageId}/`  : matchedLink,
              ...(!['CALL_NOW','LIKE_PAGE'].includes(type) && {display_url: matchedCaption})
            }],
          },
        };
      });

      const matchedAdCreatives = matchingGroups.map(group => {
        const file = group[0];
        const strippedName = getFileNameWithoutExtension(file?.name)?.trim();
        const fileName = strippedName ? strippedName : `Ad_${formatDateTime()}`;

        return {
          adsAccountId: file?.adsAccountId || '',
          fileName: fileName,
          hash: file?.mediaHash || '',
          [file.mediaType === 'image' ? 'image_hash' : 'video_id']: file?.hash,
          url: file.mediaType === 'image' ? file?.url || '' : file?.source || '',
          thumbnail: file?.mediaType === 'video' ? file?.url || '' : '',
        };
      });

      matchedAdCreatives.forEach(item => adcreatives.push(item));

      const linksPayload = link
        .filter(item => item.link?.trim() !== '' || item.caption?.trim() !== '')
        .map(item => ({
          adsAccountId: item.adsAccountId,
          link: item.link,
          caption: item.caption,
      }));

      const templateUrlSpec = link
        .filter(item => item.app_id?.trim())
        .map(item => ({
          adsAccountId: item.adsAccountId,
          app_id: item.app_id,
        }));

      const intialPayload = {
        adType: adFormik.values.format,
        contextual_multi_ads: {
          enroll_status: adFormik.values.enroll_status,
        },
        campaign: campaignId,
        adsets: uniqueAdsets,
        ...(message?.trim() && { message }),
        name: name,
        description: description,
        type: type,
        ...(type === 'CALL_NOW' && phoneNumber?.length
          ? {
              links: phoneNumber.map(item => ({
                adsAccountId: item.adsAccountId,
                link: `tel:+${item.phoneNumber}`
              }))
            }
          : type === 'LIKE_PAGE'
          ? {
              links: (adFormik?.values?.accounts || []).map(account => ({
                adsAccountId: account.adsAccountId,
                link: account.page_id
              }))
            }
          : {
              ...(linksPayload.length > 0 && { links: linksPayload })
            }
        ),        
        ...((templateUrlSpec.length > 0 && (objective === 'OUTCOME_AWARENESS' || activeDestinationType === 'ON_VIDEO')) && { template_url_spec: templateUrlSpec }),
        ...(urlTags.length > 0 && { url_tags: urlTags }),
        adcreatives: adcreatives,
        adsAccounts: adsAccounts,
        ...(type !== 'LIKE_PAGE' ? {
          degrees_of_freedom_spec: {
            creative_features_spec: {
              pac_relaxation: {
                enroll_status: pac_relaxation_enroll_status,
              }
            }
          }
        } : {}),        
      };

      const payload = removeEmptyValues(intialPayload);

      try {
        if (uploadPurpose === 'create') {

          createAdspressoAds(payload).unwrap()
            .then(response => {
              toast({
                position: "top-right",
                title: "Ad creative added",
                status: "success",
                duration: 4000,
                isClosable: true,
              });
              // console.log('Ads creative created successfully:', response);
            })
            .catch(error => {
              const errorMessage = error?.message || "An unexpected error occurred";

              toast({
                position: "top-right",
                title: "Error creating Ad creative",
                description: errorMessage,
                status: "error",
                duration: 4000,
                isClosable: true,
              });
            });
        }
      } catch {
      } finally {
        setuploadPurpose(null);
        setMediaType(null);
        setMediaFiles([]);
        setSelectedAdAccounts([]);
        setSelectedAdSets({});
        resetForm();
        setactiveDestinationType('');
        setselectedMediaUrls([]);
        setLinks([]);
        setPhoneNumbers([]);
        seturl_tags([]);
      }
    },
  });

  const handleDeleteFile = (indexToDelete) => {
    setMediaFiles((prevFiles) => prevFiles.filter((_, index) => index !== indexToDelete));
    setselectedMediaUrls((prevFiles) => prevFiles.filter((_, index) => index !== indexToDelete));
  };

  const handleEditPlacement = (indexToEdit) => {
    setEditingGroupIndex(indexToEdit);
    OnEditModalOpen();
  };

  const handleReplaceImage = (type, groupIndex, placementIndex) => {
    setMediaType(type);
    setReplacingIndex({ groupIndex, placementIndex });
    OnReplaceModalOpen();
  };

  const handleImageSelectedFromReplaceDrive = (file) => {
    if (file && file.length > 0) {
      const newImageUrl = file[0];

      setselectedMediaUrls((prev) =>
        prev.map((group, groupIdx) => {
          if (groupIdx !== replacingIndex.groupIndex) return group;

          // Replace only the placement within the correct group
          return group.map((placementItem, placementIdx) => {
            if (placementIdx !== replacingIndex.placementIndex) return placementItem;

            return {
              ...placementItem,
              url: newImageUrl?.url || newImageUrl?.picture,
              hash: newImageUrl?.creativeId,
              mediaHash: newImageUrl?.hash,
              name: newImageUrl?.name,
              source: newImageUrl?.source,

            };
          });
        })
      );
    }

    setReplacingIndex(null);
    OnReplaceModalClose();
  };

  useEffect(() => {
    singleMediaFormik.setFieldValue('mediaFiles', mediaFiles)
  }, [mediaFiles])

  const handleDeleteAd = (adId) => {
    removeAd(adId)
      .unwrap()
      .then(response => {
        toast({
          position: "top-right",
          title: "Ad deleted",
          status: "success",
          duration: 4000,
          isClosable: true,
        });
      })
      .catch(error => {
        toast({
          position: "top-right",
          title: "Error deleting Ad",
          status: "error",
          description: error?.data?.message,
          duration: 4000,
          isClosable: true,
        });
      });
  };

  const confirmDelete = () => {
    if (selectedAd) {
      handleDeleteAd(selectedAd);
      setModalOpen(false);
      setSelectedAd(null);
    }
  };

  function checkSameDestinationType(selectedIds, adsets) {
    const filteredAdsets = adsets.filter(adset => selectedIds.includes(adset._id));

    if (filteredAdsets.length === 0) {
      return true;
    }

    // Get the destination_type of the first filtered adset
    const firstDestinationType = filteredAdsets[0].destination_type;

    // Loop through the filtered adsets and check if all have the same destination_type
    for (let i = 1; i < filteredAdsets.length; i++) {
      if (filteredAdsets[i].destination_type !== firstDestinationType) {
        return false;
      }
    }

    setactiveDestinationType(firstDestinationType);


    return true;
  }

  useEffect(() => {
    const selectedIds = Object.values(selectedAdSets)?.flat() || [];
    const selectedAdsetsFull = adsetsListData?.data?.filter(adset =>
      selectedIds.includes(adset._id)
    ) || [];
  
    if (selectedIds.length > 1) {
      const checkresult = checkSameDestinationType(selectedIds, adsetsListData?.data);
      sethasSameDestinationType(checkresult);
    } else if (selectedIds.length === 1) {
      const single = selectedAdsetsFull?.[0];
      setactiveDestinationType(single?.destination_type);
      sethasSameDestinationType(true);
    } else {
      setactiveDestinationType('');
    }
  
    // Check if any selected adset has video optimization goal
    const isVideoOptimized = selectedAdsetsFull.some(adset =>
      ["THRUPLAY", "TWO_SECOND_CONTINUOUS_VIDEO_VIEWS"].includes(adset.optimization_goal)
    );
    setIsVideoOptimized(isVideoOptimized); 
  
  }, [selectedAdSets, adsetsListData?.data]);
  

  const updateLinkField = (adsAccountId, field, value) => {
    setLinks(prevLinks => {
      const updatedLinks = prevLinks.map(link =>
        link.adsAccountId === adsAccountId ? { ...link, [field]: value } : link
      );
      singleMediaFormik.setFieldValue('link', updatedLinks);
      return updatedLinks;
    });
  };  

  const handlePhoneNumberChange = (adsAccountId, value) => {
    setPhoneNumbers(prevPhoneNumbers => {
      const updatedPhoneNumbers = prevPhoneNumbers.map(phone =>
        phone.adsAccountId === adsAccountId ? { ...phone, phoneNumber: value } : phone
      );
      singleMediaFormik.setFieldValue('phoneNumber', updatedPhoneNumbers); // Update formik field
      return updatedPhoneNumbers;
    });
  };

  const handleUrlChange = (constructedUrl, adsAccountId) => {
    setLinks((prevLinks) => {
      const updatedLinks = prevLinks.map((link) =>
        link.adsAccountId === adsAccountId ? { ...link, link: constructedUrl } : link
      );
      singleMediaFormik.setFieldValue('link', updatedLinks);
      return updatedLinks;
    });
  };

  const handleUrlTagChange = (adsAccountId, value) => {
    seturl_tags(prevUrl => {
      const updatedUrl = prevUrl.map(url =>
        url.adsAccountId === adsAccountId ? { ...url, url_tags: value } : url
      );
      singleMediaFormik.setFieldValue('url_tags', updatedUrl);
      return updatedUrl;
    });
  };

  const handleUrlParamChange = (constructedUrl, adsAccountId) => {
    seturl_tags(prevUrl => {
      const updatedUrl = prevUrl.map(url =>
        url.adsAccountId === adsAccountId ? { ...url, url_tags: constructedUrl } : url
      );
      singleMediaFormik.setFieldValue('url_tags', updatedUrl);
      return updatedUrl;
    });
  };

  const handleAiUploadedMedia = (data) => {
    const mappedMediaFiles = data.map(item => {
      const dynamicKeyData = item[item?.name] || {};

      return {
        creativeType: item?.creativeType,
        creativeId: item?.creativeId,
        source: item?.source,
        url: dynamicKeyData?.url || "",
        picture: dynamicKeyData?.url || "",
        hash: item?.hash,
        name: item?.name,
        adsAccount: {
          adsAccountId: item?.adsAccount?.adsAccountId
        }
      };
    });

    // Update media files
    setMediaFiles(prevFiles => [...prevFiles, ...mappedMediaFiles]);
  };

  const allLinksAdded =
    !['PHONE_CALL', 'ON_PAGE'].includes(activeDestinationType) &&
    links.every(link => link?.link !== '');

  const allPhoneNumbersAdded = activeDestinationType === 'PHONE_CALL' && phoneNumbers.every(phone => phone?.phoneNumber !== '');


  const handleFocus = (adsAccountId) => {
    // Set the field as focused when the user starts typing
    setIsFocused(prev => ({
      ...prev,
      [adsAccountId]: true
    }));
  };


  const isAccountsMatching = !singleMediaFormik.values.mediaFiles.every(mediaFile =>
    selectedAdAccounts.some(account => account.adsAccountId === mediaFile.adsAccount?.adsAccountId)
  ) ||
    !selectedAdAccounts.every(account =>
      singleMediaFormik.values.mediaFiles.some(mediaFile => mediaFile.adsAccount?.adsAccountId === account.adsAccountId)
  )

  const getSelectedAccountFromMediaUrls = () => {
    if (
      editingGroupIndex !== null && 
      selectedMediaUrls && 
      selectedMediaUrls[editingGroupIndex] && 
      selectedMediaUrls[editingGroupIndex].length > 0
    ) {
      const { adsAccountId, adsAccountName } = selectedMediaUrls[editingGroupIndex][0];
      return [{ adsAccountId, adsAccountName }];
    }
    return [];
  };

  // Group mediaFiles by adsAccountId and keep original index for delete/edit
  const groupedByAccount = useMemo(() => {
    const withIdx = mediaFiles.map((m, idx) => ({ ...m, __idx: idx }));
    return withIdx.reduce((acc, item) => {
      const accountId = item?.adsAccount?.adsAccountId || item?.adsAccountId || 'unknown';
      const accountName = item?.adsAccount?.adsAccountName || item?.adsAccountName || accountId;

      if (!acc[accountId]) {
        acc[accountId] = { accountId, accountName, items: [] };
      }
      acc[accountId].items.push(item);
      return acc;
    }, {});
  }, [mediaFiles]);

  return (
    <>

      <Modal
        isOpen={isCreativeModalOpen}
        onClose={() => {
          onCreativeModalClose();
          setMediaType(null);
        }}
        isCentered
        closeOnOverlayClick={false}
        closeOnEsc={false}
      >
        <ModalOverlay />
        <ModalContent maxW={{ base: "95vw", md: "80vw" }} minH="80vh">
          <Divider />
          <ModalBody p={0}>
            <Flex minH="90vh" w="100%">
              {/* Sidebar */}
              <Box
                w={{ base: "260px", md: "200px" }}
                bgGradient={bgGradient}
                borderRight="1px solid"
                borderColor={useColorModeValue("gray.200", "whiteAlpha.300")}
                px={4}
                py={3}
              >
                <Text fontWeight={"bold"} mb={4}>
                  Set up your creative
                </Text>
                <ButtonGroup orientation="vertical" spacing={3} display="flex" flexDir="column">
                  <StepButton isActive={activeStep === "Media"} onClick={() => setActiveStep("Media")}>
                    Media
                  </StepButton>
                  <Tooltip
                      label="Finish the Media step to proceed to the Replace."
                      isDisabled={hasSelectedFiles}
                      placement="bottom"
                      fontSize={'12px'}
                      hasArrow
                    >
                      <span>
                        <StepButton
                          isActive={activeStep === "Replace"}
                          onClick={() => setActiveStep("Replace")}
                          isDisabled={!hasSelectedFiles}
                        >
                          Replace
                        </StepButton>
                      </span>
                  </Tooltip>
                </ButtonGroup>
              </Box>

              {/* Main content area */}
              <Box flex="1" py={3} px={2}>
                {/* Dynamic header with close button */}
                {(() => {
                  const meta = getStepMeta(activeStep, mediaType);
                  return (
                    <Box position="sticky" top={0} zIndex={1}>
                      <Flex>
                        <Flex gap={1} direction={"column"} flex={"98%"}>
                          <Text fontWeight={"bold"}>{meta.title}</Text>
                          <Text fontSize="12px">
                            {meta.desc}
                          </Text>
                        </Flex>
                        <Flex flex={"2%"}>
                          <IconButton
                            aria-label="Close"
                            icon={<CloseIcon boxSize={3} />}
                            variant="ghost"
                            onClick={() => {
                              onCreativeModalClose();
                              setMediaType(null);
                              setActiveStep('Media')
                            }}
                            size="sm"
                            alignSelf="flex-start"
                          />
                        </Flex>
                      </Flex>
                    </Box>
                  );
                })()}

                {/* Step body (swap your real components in) */}
                {activeStep === "Media" ? (
                  <DriveComponent
                    mediaType={mediaType}
                    selectedAdAccounts={selectedAdAccounts}
                    uploadPurpose={uploadPurpose}
                    onSubmit={handleFileSelect}
                    activeStep={"Media"}
                    setActiveStep={setActiveStep}
                    setHasSelectedFiles={setHasSelectedFiles}
                    onClose={() => {
                      onCreativeModalClose();
                      setMediaType(null);
                      setActiveStep('Media');
                      setHasSelectedFiles(false)
                    }}
                  />
                ) : (
                  <ReplaceComponent
                    selectedMediaUrls={selectedMediaUrls}
                    setselectedMediaUrls={setselectedMediaUrls}
                    mediaType={mediaType}
                    onClose={() => {
                      onCreativeModalClose();
                      setMediaType(null);
                      setActiveStep('Media');
                    }}
                    setMediaFiles={setMediaFiles}
                    setActiveStep={setActiveStep}
                  />
                )}
              </Box>
            </Flex>
          </ModalBody>
        </ModalContent>
      </Modal>

      <Modal isOpen={isUrlModalOpen} onClose={() => setUrlModalOpen(false)} scrollBehavior={"inside"}
        size={"2xl"}
        isCentered={true}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader css={{ boxShadow: '0 0px 5px rgba(0, 0, 0, 0.1)' }}>Build a URL parameter</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <BuildUrlParams links={links} onClose={() => setUrlModalOpen(false)} onUrlChange={handleUrlChange} selectedAccountId={selectedAccountId} />
          </ModalBody>
        </ModalContent>
      </Modal>

      <Modal isOpen={isUrlParamModalOpen} onClose={() => setUrlParamModalOpen(false)} scrollBehavior={"inside"}
        size={"2xl"}
        isCentered={true}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader css={{ boxShadow: '0 0px 5px rgba(0, 0, 0, 0.1)' }}>Build a URL parameter</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <UrlParameter urls={url_tags} onClose={() => setUrlParamModalOpen(false)} onUrlChange={handleUrlParamChange} selectedAccountId={selectedAccountId} />
          </ModalBody>
        </ModalContent>
      </Modal>

      <Modal isOpen={isEditModalOpen} onClose={OnEditModalClose} scrollBehavior={"inside"} size={"5xl"} isCentered={true}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Select media for placements</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <>
              <ReplaceDriveModal
                isDriveModalOpen={isReplaceModalOpen}
                selectedAdAccounts={getSelectedAccountFromMediaUrls()}
                onClose={() => {
                  OnReplaceModalClose();
                  setMediaType(null);
                }}
                onSubmit={handleImageSelectedFromReplaceDrive}
                uploadPurpose="update"
                mediaType={mediaType}
              />
              <Flex wrap="wrap" gap={2} justifyContent={'center'}>
                {selectedMediaUrls?.map((group, groupIndex) =>
                  group.map(({ placement, url, source, mediaType }, placementIndex) => {

                    const isEditing = editingGroupIndex !== null && editingGroupIndex === groupIndex;

                    return isEditing ? (
                      <Box
                        key={`${groupIndex}-${placement}`}
                        border="1px solid"
                        borderColor={'gray.100'}
                        borderRadius="md"
                        p={2}
                        width={'240px'}
                        height={
                          placement === 'square'
                            ? '300px'
                            : placement === 'vertical'
                              ? '530px'
                              : '230px'
                        }
                        display="flex"
                        flexDirection="column"
                        gap={2}
                      >
                        <Text fontWeight="bold" textTransform="capitalize">
                          {placement}
                        </Text>
                        {source ? (
                            <Box
                              width="220px"
                              height={
                                placement === 'square'
                                  ? '200px'
                                  : placement === 'vertical'
                                    ? '440px'
                                    : '120px'
                              }
                              display="flex"
                              alignItems="center"
                              justifyContent="center"
                              bg="gray.200"
                              borderRadius="md"
                            >
                              <Box
                                as="video"
                                controls
                                src={source}
                                maxWidth="100%"
                                maxHeight="100%"
                                style={{ objectFit: 'contain', objectPosition: 'center' }}
                              />
                          </Box>
                        ) : (
                          <Box
                            width="220px"
                            height={
                              placement === 'square'
                                ? '200px'
                                : placement === 'vertical'
                                  ? '430px'
                                  : '120px'
                            }
                            display="flex"
                            alignItems="center"
                            justifyContent="center"
                            bg="gray.200"               
                            borderRadius="md"
                          >
                            <Image
                              src={url}
                              alt={placement}
                              maxWidth="100%"
                              maxHeight="100%"
                              objectFit="contain"      
                              objectPosition="center"  
                            />
                          </Box>
                        )}
                        <Flex>
                          <Button
                            size="sm"
                            variant={'solid'}
                            colorScheme={'gray'}
                            mt={2}
                            leftIcon={<FaExchangeAlt />}
                            onClick={() =>
                              handleReplaceImage(mediaType, groupIndex, placementIndex)
                            }
                          >
                            Replace
                          </Button>
                        </Flex>
                      </Box>
                    ) : null;
                  })
                )}
              </Flex>
            </>
          </ModalBody>
          <ModalFooter gap={2}>
            <Button 
              colorScheme="gray"
              variant="solid"
              size={'sm'} 
              onClick={OnEditModalClose}
            >
              Cancel
            </Button>
            <Button colorScheme="brand" size={'sm'} onClick={OnEditModalClose}>
              Save
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <Modal
        isOpen={isAiImageModalOpen}
        onClose={onAiImageModalClose} scrollBehavior={"inside"}
        size={"5xl"}
        isCentered={true}
        closeOnOverlayClick={false}
        closeOnEsc={false}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            <Flex gap={2} direction={'column'}>
              <Flex alignItems={'center'} gap={2}>
                <BsStars />
                <Text>AI Image Generation</Text>
                <Tooltip
                  borderRadius={5}
                  label={
                      <Flex direction={'column'} gap={2} fontSize="12px" p="5px">
                          <Text fontWeight={'bold'}>Generated with AI</Text>
                          <Text>AI-generated image variations are inspired by your original asset. Adding multiple image options to your ad can help tailor creatives to different audiences, reduce creative fatigue, and improve overall performance.</Text>
                          <Flex direction={'column'} gap={2}>
                              <Text fontWeight={'bold'}>Types of AI Variations:</Text>
                              <Text>Background Variation: Your product is placed in different, relevant environments.</Text>
                              <Text>Creative Variation: Entirely new visuals generated based on your original creative.</Text>
                          </Flex>
                          <Text>Note: Hustle does not guarantee the completeness, accuracy, or reliability of AI-generated images.</Text>
                      </Flex>
                  }
                  fontSize="md"
              >
                  <InfoOutlineIcon pointerEvents="all" />
              </Tooltip>
              </Flex>
            </Flex>
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <AiImageModal selectedAdAccounts={selectedAdAccounts} onClose={onAiImageModalClose} onUploadComplete={handleAiUploadedMedia} />
          </ModalBody>
        </ModalContent>
      </Modal>

      {/* Upload Video Modal */}
      <Modal
        size={"6xl"}
        isCentered={true}
        isOpen={isAiVideoModalOpen}
        scrollBehavior={"inside"}
        onClose={onAiVideoModalClose}
        closeOnOverlayClick={false}
        closeOnEsc={false}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalBody>
            <AiVideoModal
              isOpen={isAiVideoModalOpen}
              selectedAdAccounts={selectedAdAccounts}
              onClose={() => {
                onAiVideoModalClose();
              }}
            />
          </ModalBody>
        </ModalContent>
      </Modal>

      <DeleteConfirmationModal
        isOpen={isModalOpen}
        onClose={() => setModalOpen(false)}
        onConfirm={confirmDelete}
        message="Do you wish to proceed with deleting this Ad?"
      />

      <Flex flex="3" direction="column" gap={2}>
        <Flex direction="column" >
          {/* Ad Account Select */}
          <Flex direction={'column'} gap={'10px'} mb={'10px'}>
            <Text fontSize={'14px'} fontWeight={'bold'}>Select Ad accounts</Text>
            <CheckboxGroup
              colorScheme="brand"
              value={selectedAdAccounts.map(account => account.adsAccountId)}
              onChange={handleAdAccountChange}
              isDisabled={userInfo?.role !== 'client'}
            >
              {adsAccounts?.map(account => (
                <Box key={account.adsAccountId} px={'5px'} py={'2px'}>
                  <Checkbox value={account.adsAccountId}>
                    <Text fontSize={'14px'} noOfLines={2} maxWidth={'510px'}>
                      {account.adsAccountName}
                    </Text>
                  </Checkbox>
                </Box>
              ))}
            </CheckboxGroup>
          </Flex>


          {/* Ad Set Select */}
          <Flex direction="column" gap={'5px'} mb={'20px'}>
            <Text fontSize={'14px'} fontWeight={'bold'}>Select Ad sets</Text>
            <CheckboxGroup
              colorScheme="brand"
              value={Array.from(new Set(Object.values(selectedAdSets).flat()))}
              onChange={(e) => {
                handleAdSetChange(e);
              }}
              isDisabled={!selectedAdAccounts.length > 0}
            >
              {adsetsListData?.data?.map((adSet, index) => (
                <Box key={`${adSet._id}-${index}`} px={'5px'} py={'2px'}>
                  <Checkbox value={adSet._id} display={'flex'} flex={1}>
                    <Text fontSize={'14px'} noOfLines={2} maxWidth={'510px'}>{adSet?.name}</Text>
                  </Checkbox>
                </Box>
              ))}
            </CheckboxGroup>

            {!hasSameDestinationType ? (
              <Flex>
                <Text color="red.500" fontSize={'12px'}>Conversion goals don't match &nbsp;
                </Text>
                <Tooltip
                  borderRadius={5}
                  label={
                    <Box fontSize="14px" p="5px">
                      <Text>
                        The selected Ad sets have different conversion goals. Please select Ad sets with the same goal (either Website or Calls). You can create a separate set of Ads for the other conversion goal thereafter.
                      </Text>
                    </Box>
                  }
                  fontSize="md"
                >
                  <InfoOutlineIcon pointerEvents="all" color={'red.500'} boxSize={4} />
                </Tooltip>
              </Flex>
            ) : null}

            {/* {isVideoOptimized ? (
              <Flex>
                <Text color="red.500" fontSize={'12px'}>Performance goals don't match &nbsp;
                </Text>
                <Tooltip
                  borderRadius={5}
                  label={
                    <Box fontSize="14px" p="5px">
                      <Text>
                        The selected Ad sets have different Performance goals. Please select Ad sets with the same goal. You can create a separate set of Ads for the other Performance goal thereafter.
                      </Text>
                    </Box>
                  }
                  fontSize="md"
                >
                  <InfoOutlineIcon pointerEvents="all" color={'red.500'} boxSize={4} />
                </Tooltip>
              </Flex>
            ) : null} */}

          </Flex>

          {/* Single Select component for each adAccount */}
          <Flex direction="row" flexShrink={0} alignItems={'center'} justifyContent={'space-between'}>
                  {isVideoOptimized ? (
                      <Button
                          colorScheme="gray"
                          variant="solid"
                          size="sm"
                          border={'1px solid'}
                          bg={bgColor}
                          color={textColor}
                          borderColor={boxBorder}
                          _hover={{
                              bg: bgColor,
                              color: textColor,
                              borderColor: hoverBorderColor,
                          }}
                          _active={{
                              bg: bgColor,
                              color: textColor,
                              borderColor: hoverBorderColor,
                          }}
                          fontWeight={'normal'}
                          isDisabled={Object.keys(selectedAdSets)?.length === 0 || !selectedAdAccounts?.length > 0 || !hasSameDestinationType}
                          leftIcon={<IoPlayCircleOutline size={'15px'}/>}
                          onClick={() => { setuploadPurpose('create'); handleMediaTypeChange(selectedAdAccounts, "video")} 
                        }
                      >
                      Add video
                      </Button>
                  ) : (
                      <Select
                        placeholder={singleMediaFormik?.values?.format === 'CAROUSEL' ? "Add cards" : "Add media"}
                        width={'150px'}
                        name="mediaOption"
                        borderRadius={'md'}
                        value={mediaType || ""}
                        onChange={(e) => {
                          setuploadPurpose('create');
                          handleMediaTypeChange(selectedAdAccounts, e.target.value);
                        }}
                        size="sm"
                        isDisabled={Object.keys(selectedAdSets)?.length === 0 || !selectedAdAccounts?.length > 0 || !hasSameDestinationType}
                      >
                        <option value="image">{"Add image"}</option>
                        <option value="video">{"Add video"}</option>
                      </Select>
            )}

            <Flex alignItems={'center'} gap={2}>
              {isVideoOptimized ? (
                <>
                  <Button
                    colorScheme="brand"
                    size="sm"
                    leftIcon={<BsStars size={16} />}
                    onClick={onAiVideoModalOpen}
                    isDisabled={
                    Object.keys(selectedAdSets)?.length === 0 ||
                    !selectedAdAccounts?.length > 0 ||
                    !hasSameDestinationType
                  }
                >
                  AI Video Generatation
                </Button>

                <Tooltip
                    borderRadius={5}
                    label={
                        <Flex direction={'column'} gap={2} fontSize="12px" p="5px">
                            <Text fontWeight={'bold'}>AI Video Generation</Text>
                            <Text>AI-generated video ads are created using your product information and visuals. By assembling product highlights, voiceovers, and dynamic visuals, the AI helps generate high-performing video ads optimised for various platforms.</Text>
                            <Flex direction={'column'} gap={2}>
                                <Text fontWeight={'bold'}>Types of AI Variations:</Text>
                                <Text>Product URL Based: Extracts product details from your URL to auto-generate video content.</Text>
                                <Text>Asset Based: Uses your uploaded visuals to create fully edited video ads.</Text>
                            </Flex>
                            <Text>Note: Hustle does not guarantee the completeness, accuracy, or reliability of AI-generated videos.</Text>
                        </Flex>
                    }
                    fontSize="md"
                >
                    <InfoOutlineIcon pointerEvents="all" />
                </Tooltip>
               </>
              ):(
                <>
                  <Menu>
                    <MenuButton
                      as={Button}
                      colorScheme='brand'
                      size='sm'
                      _expanded={{ bg: 'orange.600' }}
                      rightIcon={<ChevronDownIcon boxSize={5} />}
                      isDisabled={
                        Object.keys(selectedAdSets)?.length === 0 ||
                        !selectedAdAccounts?.length > 0 ||
                        !hasSameDestinationType
                      }
                    >
                      <Flex align="center">
                        <Icon as={BsStars} boxSize={4} mr={2} />
                        AI Generation
                      </Flex>
                    </MenuButton>
                    <MenuList sx={{ minWidth: "180px" }}>
                      <MenuItem onClick={onAiImageModalOpen} fontSize='14px'>
                        Generate Image
                      </MenuItem>
                      <MenuItem onClick={onAiVideoModalOpen} fontSize='14px'>
                        Generate Video
                      </MenuItem>
                    </MenuList>
                  </Menu>

                  <Tooltip
                  borderRadius={5}
                  label={
                    <Flex direction={'column'} gap={4} fontSize="12px" p="5px">
                      <Flex direction={'column'} gap={2}>
                        <Text fontWeight={'bold'}>AI Image Generation</Text>
                        <Text>AI-generated image variations are inspired by your original asset.</Text>
                        <Flex direction={'column'} gap={2}>
                          <Text fontWeight={'bold'}>Types of AI Variations:</Text>
                          <Text>Background Variation: Your product is placed in different, relevant environments.</Text>
                          <Text>Creative Variation: Entirely new visuals generated based on your original creative.</Text>
                        </Flex>
                      </Flex>
                      <Flex direction={'column'} gap={2}>
                        <Text fontWeight={'bold'}>AI Video Generation</Text>
                        <Text>AI-generated video ads are created using your product information, images, or scripts.</Text>
                        <Flex direction={'column'} gap={2}>
                          <Text fontWeight={'bold'}>Types of AI Variations:</Text>
                          <Text>Product URL Based: Generates video using product details pulled from your URL.</Text>
                          <Text>Asset Based: Combines your visual assets into fully edited video ads.</Text>
                        </Flex>
                      </Flex>
                      <Text>Note: Hustle does not guarantee the completeness, accuracy, or reliability of AI-generated assets.</Text>
                    </Flex>
                  }
                  fontSize="md"
                >
                  <InfoOutlineIcon pointerEvents="all" />
                  </Tooltip>
                </>
              )}
            </Flex>
          </Flex>

          {/*  Media Previews */}
          {mediaFiles?.length > 0 && (
            <Box mt="10px">
              {Object.values(groupedByAccount).map((group) => (
                <Box
                  key={group.accountId}
                  mb={2}
                  p={3}
                  borderWidth={1}
                  borderRadius="md"
                  borderColor={boxBorder}
                >
                  <Flex align="center" justify="space-between" mb={3}>
                    <Text fontWeight="bold" fontSize="14px">
                      {group.accountName}
                    </Text>
                  </Flex>

                  <Flex wrap="wrap" gap="10px">
                    {group.items.map((file) => (
                      <Box
                        key={file.__idx}
                        p={1}
                        borderWidth={1}
                        borderRadius="md"
                        borderColor={boxBorder}
                        bg={bgColor}
                      >
                        <Box width="80px">
                          {file?.creativeType === 'image' ? (
                            <img
                              src={file?.url}
                              alt={file?.name}
                              style={{ width: '80px', height: '60px',  objectFit: 'cover', borderRadius: '3px' }}
                            />
                          ) : (
                            <img
                              src={file?.picture}
                              style={{ width: '80px', height: '60px', objectFit: 'cover', borderRadius: '3px' }}
                            />
                          )}
                          <Text fontSize="10px" noOfLines={1}>
                            {truncateString(file?.name, 16)}
                          </Text>
                        </Box>

                        <Flex mt="5px" gap="5px" align="center" justify="space-between">
                          {['WEBSITE_AND_PHONE_CALL', 'WEBSITE_AND_LEAD_FORM'].includes(activeDestinationType) ? (
                            <Flex />
                          ) : (
                            <Tooltip label="Edit Media" fontSize="xs">
                              <Box height="20px">
                                <Icon
                                  _hover={{ color: 'gray.400' }}
                                  as={MdEdit}
                                  cursor="pointer"
                                  fontSize="18px"
                                  onClick={() => handleEditPlacement(file.__idx)}
                                />
                              </Box>
                            </Tooltip>
                          )}

                          <Tooltip label="Remove Media" fontSize="xs">
                            <Box height="20px">
                              <Icon
                                color="red.500"
                                _hover={{ color: 'gray.400' }}
                                as={MdDelete}
                                cursor="pointer"
                                fontSize="18px"
                                onClick={() => handleDeleteFile(file.__idx)}
                              />
                            </Box>
                          </Tooltip>
                        </Flex>
                      </Box>
                    ))}
                  </Flex>
                </Box>
              ))}
               {activeDestinationType === 'ON_PAGE' ? null :
                  <Flex alignItems={'center'} gap={2}>
                      <Switch colorScheme='brand' size={'sm'} isChecked={singleMediaFormik.values.pac_relaxation_enroll_status === 'OPT_IN'} onChange={(e) => singleMediaFormik.setFieldValue('pac_relaxation_enroll_status', e.target.checked ? 'OPT_IN' : 'OPT_OUT')} />
                      <Text fontSize="12px">We'll deliver your media selections across your placements when it's likely to improve performance.</Text>
                  </Flex>
                }
            </Box>
          )}

        </Flex>

        <Divider mt={'10px'} />

        <Box direction="column" mb={4}>
          <Flex alignItems="center" mb={2}>
            <Text fontWeight="bold" fontSize={'14px'} mr={2}>Primary text</Text>
            {/* <Text display="inline-flex" fontSize="18px" color="red.400" mr={2}>*</Text> */}
            <Tooltip
              borderRadius={5}
              label={
                <Box fontSize="12px" p="5px">
                  <Text>
                    The primary text for your ad appears in most placements, though the position
                    varies. You can use @ to tag Facebook profiles or Pages. We recommend 125
                    characters or less.
                  </Text>
                </Box>
              }
              fontSize="md">
              <InfoOutlineIcon pointerEvents="all" />
            </Tooltip>
          </Flex>
          <Textarea
            size={'sm'}
            placeholder="Tell people what your ad is about..."

            name="message"
            value={singleMediaFormik.values.message}
            onChange={singleMediaFormik.handleChange}
            onBlur={singleMediaFormik.handleBlur}
            borderRadius={'md'}
          />

          {singleMediaFormik.touched.message && singleMediaFormik.errors.message ? (
            <Text color="red.500" fontSize={'12px'}>{singleMediaFormik.errors.message}</Text>
          ) : null}
        </Box>
        
        {activeDestinationType === 'ON_PAGE' ? null :
          <Box direction="column" mb={4}>
            <Flex alignItems="center" mb={2} gap={2}>
              <Text fontWeight="bold" fontSize={'14px'}>Headline</Text>
              <Tooltip
                borderRadius={5}
                label={
                  <Box fontSize="12px" p="5px">
                    <Text>
                      Add up to five brief headlines to let people know what your ad is about. Each
                      headline can have a maximum of 255 characters. Headlines won't appear in all
                      placements.
                    </Text>
                  </Box>
                }
                fontSize="md">
                <InfoOutlineIcon pointerEvents="all" />
              </Tooltip>
            </Flex>
            <Input
              size={'sm'}
              placeholder="Write a short headline"
              borderRadius={'md'}
              name="name"
              value={singleMediaFormik.values.name}
              onChange={singleMediaFormik.handleChange}
              onBlur={singleMediaFormik.handleBlur}
            />

            {singleMediaFormik.touched.name && singleMediaFormik.errors.name ? (
              <Text color="red.500" fontSize={'12px'}>{singleMediaFormik.errors.name}</Text>
            ) : null}
          </Box>
        }

        {activeDestinationType === 'ON_PAGE' ? null :
          <Box direction="column" mb={'10px'}>
            <Flex alignItems="center" mb={2} gap={2}>
              <Text fontWeight="bold" fontSize={'14px'}>Description</Text>
              <Tooltip
                borderRadius={5}
                label={
                  <Box fontSize="12px" p="5px">
                    <Text>
                      Add up to five link descriptions to emphasise why people should visit your
                      website. This won't appear in all placements.
                    </Text>
                  </Box>
                }
                fontSize="md">
                <InfoOutlineIcon pointerEvents="all" />
              </Tooltip>
            </Flex>
            <Textarea
              size={'sm'}
              placeholder="Include additional details"

              borderRadius={'md'}
              name="description"
              value={singleMediaFormik.values.description}
              onChange={singleMediaFormik.handleChange}
              onBlur={singleMediaFormik.handleBlur}
              rows={3}
            />
            {singleMediaFormik.touched.description && singleMediaFormik.errors.description ? (
              <Text color="red.500" fontSize={'12px'}>{singleMediaFormik.errors.description}</Text>
            ) : null}
          </Box>
        }

        {activeDestinationType === 'ON_PAGE' ? null :
          <Box direction="column" mb={'10px'}>
              <Flex alignItems="center" mb={2} gap={2}>
                <Text fontWeight="bold" fontSize="14px">Call to action</Text>
                <Tooltip
                  borderRadius={5}
                  label={
                    <Box fontSize="12px" p="5px">
                      <Text>Show a button or link on your ad that represents the action you want people to take.</Text>
                    </Box>
                  }
                  fontSize="md"
                >
                  <InfoOutlineIcon pointerEvents="all" />
                </Tooltip>
              </Flex>
              {activeDestinationType === 'PHONE_CALL' ?
                <Select
                  name="type"
                  borderRadius="md"
                  value={singleMediaFormik.values.type}
                  onChange={singleMediaFormik.handleChange}
                  onBlur={singleMediaFormik.handleBlur}
                  size="sm"
                  isDisabled
              >
                  <option value="CALL_NOW">Call Now</option>
                </Select> 
              :
                <Select
                  name="type"
                  borderRadius="md"
                  value={singleMediaFormik.values.type}
                  onChange={singleMediaFormik.handleChange}
                  onBlur={singleMediaFormik.handleBlur}
                  size="sm"
                >
                {call_to_action_options_Awareness_Traffic_Engagement?.map((option) => (
                    <option key={option.value} value={option.value}>
                        {option.label}
                    </option>
                ))}
                </Select>
            }       
          </Box>
        }

        {singleMediaFormik.touched.mediaType && singleMediaFormik.errors.mediaFiles ? (
          <Text color="red.500" fontSize={'12px'}>{singleMediaFormik.errors.mediaFiles}</Text>
        ) : null}

        {/* Links Section */}

        {activeDestinationType === 'ON_PAGE' ? null :
        <>
          {selectedAdAccounts.map((account, index) => {
              const link = links.find(item => item.adsAccountId === account.adsAccountId)?.link || '';
              const phoneNumber = phoneNumbers.find(item => item.adsAccountId === account.adsAccountId)?.phoneNumber || '';
              const isValidNo = isValidPhoneNumber(phoneNumber);
              const caption = links.find(item => item.adsAccountId === account.adsAccountId)?.caption || '';
              const app_id = links.find(item => item.adsAccountId === account.adsAccountId)?.app_id || '';
              const isUrlValid = isValidUrl(link);
              const hasFocus = isFocused[account.adsAccountId];
              const urlTag = url_tags.find(item => item.adsAccountId === account.adsAccountId)?.url_tags || '';

              return (
                <React.Fragment key={`${account.adsAccountId}-${index}`}>
                  <Flex direction="column" borderWidth="1px" borderColor={boxBorder} borderRadius="md" p={2}>
                    <Flex alignItems="center" gap={2}>
                      <Text fontWeight="bold" fontSize="14px" mb={'5px'}>
                        {truncateString(account.adsAccountName, 40)}
                      </Text>
                      <Text fontSize="12px">({account.adsAccountId})</Text>
                    </Flex>
                    {activeDestinationType === 'PHONE_CALL' ? 
                      <Box pl={'5px'} mb={1}>
                        <Flex alignItems="center" mb={'5px'} >
                            <Text fontWeight="bold" fontSize="14px">
                              Call now
                            </Text>
                            <Text display="inline-flex" fontSize="18px" color="red.400" mr={2}>*</Text>
                            <Tooltip
                              borderRadius={5}
                              label={
                                <Box fontSize="12px" p="5px">
                                  <Text>Add the phone number for your business. When
                                  someone taps your ad, they can make a call to your business.</Text>
                                </Box>
                              }
                              fontSize="md"
                            >
                              <InfoOutlineIcon pointerEvents="all" />
                              </Tooltip>
                        </Flex>
                        <Box position="relative">  
                            <Flex justifyContent={'space-between'}>
                                <PhoneInput
                                    country="in"
                                    value={phoneNumber}
                                    onChange={(value) => handlePhoneNumberChange(account.adsAccountId, value)}
                                    name={`phoneNumber[${index}].phoneNumber`}
                                    inputProps={{
                                      name: `phoneNumber[${index}].phoneNumber`,
                                      required: true,
                                      onFocus: () => {
                                        // mark this account's phone input as focused
                                        handleFocus(account.adsAccountId, "phoneNumber");
                                        setShowSavedPhones(prev => ({ ...prev, [account.adsAccountId]: true }));
                                      },
                                      onBlur: () => {
                                        // let option mousedown run first
                                        setTimeout(() => {
                                          setShowSavedPhones(prev => ({ ...prev, [account.adsAccountId]: false }));
                                        }, 120);
                                      }
                                    }}
                                    enableSearch
                                    searchPlaceholder="Search"
                                    inputStyle={{
                                      backgroundColor: bgInput 
                                    }}
                                  />
                                <Button
                                  px={8}
                                  as={Link}
                                  href={`${process.env.REACT_APP_CONVERSATION_BASE_URL}/authenticateHustle?token=${userInfo?.token}`}
                                  leftIcon={<Icon as={FiPhoneCall} />}
                                  colorScheme="brand"
                                  size="sm"
                                  isExternal
                                >
                                  AI Call Center
                                </Button>
                            </Flex>

                            {/* Saved numbers dropdown - only when focused AND we have numbers */}
                            {Array.isArray(callsData?.phoneNumbers)
                              && callsData.phoneNumbers.length > 0
                              && showSavedPhones[account.adsAccountId] && (
                                <Box
                                  position="absolute"
                                  px={2}
                                  mt={1}
                                  borderWidth="1px"
                                  borderRadius="md"
                                  bg="white"
                                  boxShadow="md"
                                  maxH="180px"
                                  overflowY="auto"
                                  zIndex={20}
                                >
                                  {callsData.phoneNumbers.map((pn) => {
                                    const isSelected = phoneNumber === pn.number;
                                    return (
                                      <Box
                                        key={pn.id}
                                        as="button"
                                        type="button"
                                        width={'100%'}
                                        px={3}
                                        py={2}
                                        bg={isSelected ? "brand.50" : ListBgColor}
                                        _hover={{ bg: hoverBorder }}
                                        borderBottom="1px solid"
                                        borderColor="gray.100"
                                        onMouseDown={(e) => {
                                          e.preventDefault();
                                          const cleanNumber = pn.number?.replace(/^\+/, '');
                                          handlePhoneNumberChange(account.adsAccountId, cleanNumber);
                                          setShowSavedPhones(prev => ({ ...prev, [account.adsAccountId]: false }));
                                        }}
                                      >
                                          <Text fontWeight="medium" fontSize={'12px'} noOfLines={1}>{pn.number}</Text>
                                      </Box>
                                    );
                                  })}
                                </Box>
                            )}
                        </Box>
                        {/* Show validation error if URL is empty or invalid */}
                        {hasFocus && phoneNumber === '' && (
                          <Text color="red.500" fontSize="12px" mt={'5px'}>
                          {'Phone number is required'}
                          </Text>
                        )}
                        {hasFocus && !isValidNo && phoneNumber !== '' && (
                          <Text color="red.500" fontSize="12px" mt={'5px'}>
                            {'Please enter valid phone number'}
                          </Text>
                        )}
                    </Box>
                  : 
                    <Box pl={'5px'} mb={1}>
                        <Flex alignItems="center" mb={'5px'} >
                          <Text fontWeight="bold" fontSize="14px">
                            Website URL
                          </Text>
                          <Text display="inline-flex" fontSize="18px" color="red.400" mr={2}>*</Text>
                          <Tooltip
                            borderRadius={5}
                            label={
                              <Box fontSize="12px" p="5px">
                                <Text>Enter the URL for the webpage you want people to visit</Text>
                              </Box>
                            }
                            fontSize="md"
                          >
                            <InfoOutlineIcon pointerEvents="all" />
                          </Tooltip>
                        </Flex>
                        <Box position="relative">
                            <Flex justifyContent={'space-between'} gap={4}>
                                <Input
                                  type="url"
                                  name={`link[${index}].link`}
                                  bg="#fff"
                                  borderRadius="md"
                                  placeholder="Enter a URL"
                                  autoComplete="off"
                                  value={link}
                                  onChange={(e) => updateLinkField(account.adsAccountId, 'link', e.target.value)}
                                  onFocus={() => {
                                    handleFocus(account.adsAccountId, 'link');
                                    setShowSavedLanders((prev) => ({ ...prev, [account.adsAccountId]: true }));
                                  }}
                                  onBlur={() => {
                                    // let option mousedown run first
                                    setTimeout(() => {
                                      setShowSavedLanders((prev) => ({ ...prev, [account.adsAccountId]: false }));
                                    }, 120);
                                  }}
                                  size="sm"
                                />
                                <Button
                                  px={5}
                                  as={Link}
                                  href={`${process.env.REACT_APP_CANVA_BASE_URL}/authenticateHustle?token=${userInfo?.token}`}
                                  colorScheme="blue"
                                  size="sm"
                                  isExternal
                                  leftIcon={<Icon as={IoBuildOutline} />}
                                >
                                  Build More
                                </Button>
                              </Flex>

                            {/* Saved lander projects dropdown */}
                            {Array.isArray(landersData?.deployedProjects) &&
                              landersData.deployedProjects.length > 0 &&
                              showSavedLanders[account.adsAccountId] && (
                                <Box
                                  position="absolute"
                                  mt={1}
                                  borderWidth="1px"
                                  borderRadius="md"
                                  bg="white"
                                  boxShadow="md"
                                  maxH="180px"
                                  overflowY="auto"
                                  zIndex={20}
                                  width="100%"
                                >
                                  {landersData.deployedProjects.map((project) => {
                                    const isSelected = link === project.deploymentUrl;
                                    return (
                                      <Box
                                        key={project.uiId}
                                        as="button"
                                        type="button"
                                        width="100%"
                                        px={2}
                                        py={2}
                                        textAlign="left"
                                        bg={isSelected ? "brand.50" : ListBgColor}
                                        _hover={{ bg: hoverBorder }}
                                        onMouseDown={(e) => {
                                          e.preventDefault();
                                          updateLinkField(account.adsAccountId, "link", project.deploymentUrl);
                                          setShowSavedLanders((prev) => ({ ...prev, [account.adsAccountId]: false }));
                                        }}
                                      >
                                        <Text fontSize="12px" noOfLines={1}>
                                          {project.deploymentUrl}
                                        </Text>
                                      </Box>
                                    );
                                  })}
                                </Box>
                              )}
                        </Box>
                        
                        <Flex mt={1} mb={1}>
                          <Button onClick={() => {
                            setUrlModalOpen(true)
                            setSelectedAccountId(account?.adsAccountId);
                          }}
                          variant="link"
                          color='brand'>
                            <Text fontSize={'12px'} mt={'5px'}>{'Build a URL parameter'}</Text>
                          </Button>
                        </Flex>
                        {/* Show validation error if URL is empty or invalid */}
                        {hasFocus && link === '' && (
                          <Text color="red.500" fontSize="12px">
                            {'URL is required'}
                          </Text>
                        )}
                        {hasFocus && !isUrlValid && link !== '' && (
                          <Text color="red.500" fontSize="12px" mt={'5px'}>
                            {'Please enter valid URL'}
                          </Text>
                        )}
                    </Box>
                  }
                  

                  {activeDestinationType === 'PHONE_CALL' ? null : 
                    <Box pl={'5px'} mb={2}>
                        <Text fontWeight="bold" fontSize={'14px'} mb={'5px'}>Display link</Text>
                        <Input
                          type="url"
                          name={`link[${index}].caption`}
                          borderRadius="md"
                          placeholder="Enter the link you want to show on your ad"
                          value={caption}
                          onChange={(e) => updateLinkField(account.adsAccountId, 'caption', e.target.value)}
                          size="sm"
                        />
                    </Box>
                  }
                
                  {objective === 'OUTCOME_AWARENESS' || activeDestinationType === 'ON_VIDEO' ? 
                    <Box pl={'5px'} mb={2}>
                        <Flex alignItems="center" gap={2}>
                          <Text fontWeight="bold" fontSize={'14px'} mb={'5px'}>Mobile app</Text>
                          <Tooltip
                              borderRadius={5}
                              label={
                                  <Box fontSize="sm" p="5px">
                                      <Text>Only select a mobile app if you are using a universal link (iOS or Android app link).</Text>
                                  </Box>
                              }
                              fontSize="md"
                          >
                              <InfoOutlineIcon pointerEvents="all" />
                          </Tooltip>
                        </Flex>
                      <Select
                          name={`link[${index}].app_id`}
                          size="sm"
                          borderRadius="md"
                          onChange={(e) => updateLinkField(account.adsAccountId, 'app_id', e.target.value)}
                          value={app_id}
                      >
                          <option value="">Choose app</option>
                          {advertisableApps
                              ?.find(app => app.adsAccountId === account.adsAccountId)
                              ?.apps
                              ?.map((option) => (
                                <option key={option.id} value={option.id}>
                                  {option.name}
                                </option>
                          ))}
                      </Select>
                    </Box>
                  :null}
                  
                  {['APP', 'WHATSAPP', 'PHONE_CALL'].includes(activeDestinationType) ? null :
                    <Box pl={'5px'}>
                      <Flex alignItems={'center'}>
                        <Text mb={2} fontWeight="bold" fontSize="14px">
                          URL parameters{" "}
                          {/* <Text as="span" fontWeight="bold" color={'gray.600'} mr={1}>.</Text> */}
                          <Text as="span" fontWeight="bold" color={'gray.600'}>Optional</Text>
                        </Text>
                        <Tooltip
                          borderRadius={5}
                          label={
                            <Box fontSize="12px" p={'5px'}>
                              <Text >
                                Add parameters to the end of your website URL to track where your visitors are coming from.
                              </Text>
                            </Box>
                          }
                          fontSize="md"
                        >
                          <InfoOutlineIcon pointerEvents="all" ml={2} mb={2} />
                        </Tooltip>
                      </Flex>

                      <Input
                        type="url"
                        name={`urlTag[${index}].urlTag`}
                        borderRadius="md"
                        placeholder="key1=value1&key2=value2"
                        value={urlTag}
                        onChange={(e) => handleUrlTagChange(account.adsAccountId, e.target.value)}
                        onFocus={() => handleFocus(account.adsAccountId)}
                        size="sm"
                      />
                      <Flex mt={1} mb={2}>
                        <Button 
                          onClick={() => {
                          setUrlParamModalOpen(true)
                          setSelectedAccountId(account?.adsAccountId);
                        }}
                          variant="link"
                          color='brand'
                          >
                          <Text fontSize={'12px'} mt={'5px'}>{'Build a URL parameter'}</Text>
                        </Button>
                      </Flex>
                    </Box>
                  }
                  </Flex>
                </React.Fragment>
            );
          })}
        </>
        }

        {/* Save Button */}
        <Flex justifyContent="flex-start" mt={'10px'}>
          <Button
            colorScheme="brand"
            onClick={() => singleMediaFormik.handleSubmit()}
            isLoading={isAdsCreating}
            size={'sm'}
            isDisabled={
              !singleMediaFormik.values.mediaFiles.length > 0 ||
              !hasSameDestinationType ||
              (!['PHONE_CALL', 'ON_PAGE'].includes(activeDestinationType) && !allLinksAdded) ||
              (activeDestinationType === 'PHONE_CALL' && !allPhoneNumbersAdded) ||
              isAccountsMatching
            }
          >
            Save
          </Button>
        </Flex>

        {/* {uploadedCreativesList?.length > 0 ? (
          <>
            <Divider my={'10px'} />
            <Flex direction="column" gap={2} >
              {uploadedCreativesList}
            </Flex>
          </>
        ) : null} */}

      </Flex>
    </>
  );
}

export default SingleObjectiveMediaCreative;

